import { AwsRum } from "aws-rum-web";
import { logger } from "./logger";

const APP_MONITOR_ID = process.env.REACT_APP_RUM_APP_MONITOR_ID;
const IDENTITY_POOL_ID = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;
const REGION = process.env.REACT_APP_RUM_REGION || "ap-northeast-1";
const ENV_TAG = process.env.REACT_APP_RUM_ENV || "local";
// deploy:{dev,stg,prd} が git rev-parse --short HEAD を注入する。
// 設定時のみ渡す（未設定なら逆難読化を試みず静かにスキップ）。
const RELEASE_ID = process.env.REACT_APP_RUM_RELEASE_ID;

let rumClient = null;

/**
 * PII スクラブ: URL から soh_id / user_id / account_id 等の識別子を除去する。
 * クエリパラメータ値と数値っぽいパス要素をマスクする。
 */
const scrubUrl = (url) => {
  if (!url) return url;
  try {
    const u = new URL(url);
    // クエリパラメータ値をマスク
    const params = new URLSearchParams();
    u.searchParams.forEach((_, key) => params.set(key, "[REDACTED]"));
    u.search = params.toString();
    // 数値パスセグメント（ID 等）をマスク
    u.pathname = u.pathname.replace(/\/\d+/g, "/[ID]");
    return u.toString();
  } catch {
    return "[URL]";
  }
};

/**
 * CloudWatch RUM を初期化する。
 * REACT_APP_RUM_APP_MONITOR_ID が未設定の場合（ローカル既定）は完全スキップ。
 */
export const initRum = () => {
  if (!APP_MONITOR_ID || !IDENTITY_POOL_ID) {
    // ローカル既定は RUM 送信なし
    return;
  }

  try {
    rumClient = new AwsRum(APP_MONITOR_ID, "1.0.0", REGION, {
      allowCookies: true,
      enableXRay: false,
      sessionSampleRate: 1,
      telemetries: ["errors", "http", "performance"],
      // Enhanced フロー: identityPoolId のみ渡す（guestRoleArn は不要）
      // Cognito GetCredentialsForIdentity → roles_attachment で自動的に unauth ロールを取得
      identityPoolId: IDENTITY_POOL_ID,
      // データプレーン送信先を明示（既定は us-west-2 → 署名リージョンと不一致で 403 になる）
      endpoint: `https://dataplane.rum.${REGION}.amazonaws.com`,
      sessionAttributes: { env: ENV_TAG },
      // PII スクラブ: HTTP テレメトリの URL をマスク
      recordResourceUrl: false,
      // ソースマップ逆難読化: deploy:{dev,stg,prd} が注入する git SHA と S3 フォルダ名を一致させる
      ...(RELEASE_ID && { releaseId: RELEASE_ID }),
    });
  } catch (e) {
    // RUM 初期化失敗はアプリを停止させない
    logger.error("[RUM] init failed:", e);
  }
};

/**
 * エラーを RUM に記録する。RUM 未初期化の場合は何もしない。
 * @param {Error} error
 * @param {Object} meta - kind / status / url / componentStack など
 */
export const recordRumError = (error, meta = {}) => {
  if (!rumClient) return;
  try {
    const sanitized = { ...meta, url: scrubUrl(meta.url) };
    rumClient.recordError(error);
    // カスタムイベントで分類メタデータを追加送信
    rumClient.recordEvent("com.soh.api_error", sanitized);
  } catch {
    // RUM 記録失敗はアプリを停止させない
  }
};
